import { render, staticRenderFns } from "./GoogleSlidesInfoBox.vue?vue&type=template&id=03626604&scoped=true"
import script from "./GoogleSlidesInfoBox.vue?vue&type=script&lang=js"
export * from "./GoogleSlidesInfoBox.vue?vue&type=script&lang=js"
import style0 from "./GoogleSlidesInfoBox.vue?vue&type=style&index=0&id=03626604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03626604",
  null
  
)

export default component.exports